import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  acknowledgeSuccess,
  alternativeOfferConfirmationJobMock,
  alternativeOfferInProgressJobMock,
  getAlternativeOffersMockDisruptedInbound,
  retrieveOrderMockDisruptedOneway,
} from '../../../mock/data/index';

export const disruptedOnewayMock: MockMap = {
  retrieveOrder: [
    {
      mockData: retrieveOrderMockDisruptedOneway
    }
  ],
  getOrderEligibilities: [],
  getAlternativeOffers: [createMockData(getAlternativeOffersMockDisruptedInbound)],
  createAsynchronousJobForAlternativeOfferConfirmation: [createMockData(alternativeOfferInProgressJobMock)],
  getAlternativeOfferConfirmationJob: [createMockData(alternativeOfferConfirmationJobMock)],
  acknowledge: [createMockData(acknowledgeSuccess)]
};
